import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = ({ 
  variant = 'dropdown', // 'dropdown', 'buttons', 'toggle'
  showFlag = true,
  showName = true,
  className = ''
}) => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  const currentLangInfo = availableLanguages.find(lang => lang.code === currentLanguage);

  // Dropdown variant
  if (variant === 'dropdown') {
    return (
      <div className={`language-selector-dropdown ${className}`}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="language-selector-button"
          aria-label="Select language"
        >
          {showFlag && <span className="flag">{currentLangInfo?.flag}</span>}
          {showName && <span className="name">{currentLangInfo?.name}</span>}
          <span className="arrow">▼</span>
        </button>
        
        {isOpen && (
          <div className="language-dropdown-menu">
            {availableLanguages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`language-option ${lang.code === currentLanguage ? 'active' : ''}`}
              >
                {showFlag && <span className="flag">{lang.flag}</span>}
                {showName && <span className="name">{lang.name}</span>}
                {lang.code === currentLanguage && <span className="check">✓</span>}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Buttons variant
  if (variant === 'buttons') {
    return (
      <div className={`language-selector-buttons ${className}`}>
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`language-button ${lang.code === currentLanguage ? 'active' : ''}`}
            aria-label={`Switch to ${lang.name}`}
          >
            {showFlag && <span className="flag">{lang.flag}</span>}
            {showName && <span className="name">{lang.name}</span>}
          </button>
        ))}
      </div>
    );
  }

  // Toggle variant (compact dropdown)
  if (variant === 'toggle') {
    return (
      <div className={`language-selector-dropdown ${className}`} style={{ position: 'relative' }}>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="language-toggle-button"
          aria-label="Toggle language"
        >
          {showFlag && <span className="flag">{currentLangInfo?.flag}</span>}
          {showName && <span className="name">{currentLangInfo?.name}</span>}
          {!showName && <span style={{ fontSize: 10, color: '#64748b', marginLeft: 2 }}>▼</span>}
        </button>

        {isOpen && (
          <>
            {/* backdrop to close on outside click */}
            <div
              style={{ position: 'fixed', inset: 0, zIndex: 9998 }}
              onClick={() => setIsOpen(false)}
            />
            <div className="language-dropdown-menu" style={{ left: 0, right: 'auto', zIndex: 9999 }}>
              {availableLanguages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  className={`language-option ${lang.code === currentLanguage ? 'active' : ''}`}
                >
                  {showFlag && <span className="flag">{lang.flag}</span>}
                  <span className="name">{lang.name}</span>
                  {lang.code === currentLanguage && <span className="check">✓</span>}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  return null;
};

export default LanguageSelector;
